<div class="hero-background" [style.backgroundImage]="'url('+ featuredImage +')'">
  <div class="copyrightNotice" *ngIf="copyrightImage">&copy; {{copyrightImage}}</div>
</div>
